export default {
  clients: [],
  phone_types : [],
  autocomplete_data : [],
  autocomplete_selected : {},
  verticals : [],
  vertical_selected : {},
  countries : [],
  sic_codes:[],
  sic_codes_selected:{},
  countries_selected : {},
  head_office_country_selected : {},
  company_or_registration_no:[],
  registered_office_country_selected : {},
  company_or_registration_no_selected : {},
  searched_clients:{}
}
